import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  wrapper: {
    backgroundColor: palette.common.white,
    padding: '24px 40px'
  },
  sliderWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '24px'
  },
  slider: {
    margin: '0 10px'
  },
  input: {
    width: '130px',
    pointerEvents: 'none'
  },
  inputWrapper: {
    marginTop: '24px'
  },
  caption: {
    marginTop: '8px'
  }
}));
export default useStyles;